import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTablet: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTablet"><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H4V2H20V22ZM8 17.5V19H16V17.5H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTablet;
